// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Oy0c","title":"AfterBackImages_title__1lbB2","images":"AfterBackImages_images__23UZ_"};